import { createFileRoute, redirect } from '@tanstack/react-router'
import { repositories } from '@/data'
import { requireAuth } from '@/lib/auth-guard'
import { WelcomePage } from '@/modules/shared/components/welcome-page'

export const Route = createFileRoute('/welcome')({
  beforeLoad: async () => {
    await requireAuth()

    // Users who already have a workspace never see this screen.
    const ws = await repositories.auth.getWorkspaces()
    if (ws.organizations.length > 0 || ws.directStores.length > 0) {
      throw redirect({ to: '/' })
    }
  },
  component: WelcomePage,
})
